export const namespaceActions = (namespace, constants) =>
  Object.freeze(
    constants.reduce(
      (obj, constant) => ({
        ...obj,
        [constant]: `${namespace}/${constant}`,
      }),
      {},
    ),
  );



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/dux/utils.js